import React from "react"
import useAppState from "../../context/hooks/useAppState"
import { Flex } from "antd"
import useRefreshToken from "utilities/useRefreshToken"
import { useNavigate } from "react-router-dom"
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "constants/appState.js"

// apis
import { deleteCookie } from "api/apiUtils"
import APP_STATE from "constants/appState.js"

const useErrors = (props) => {
  const { getAccessToken, getRefreshToken, isRefreshTokenExpired, setTokens } = useRefreshToken()
  const navigate = useNavigate()
  const { openToastNotification: appOpenToastNotification, setAppState, appStateRef } = useAppState()
  const openToastNotification = props?.openToastNotificationOverride || appOpenToastNotification

  const logout = () => {
    navigate("/login")
    appStateRef.current = APP_STATE.unauthenticated
    setAppState(APP_STATE.unauthenticated)
    setTokens({
      refresh: null,
      access: null,
    })
    deleteCookie(ACCESS_TOKEN_KEY)
    deleteCookie(REFRESH_TOKEN_KEY)
  }

  const flattenErrorDetails = (obj, prefix = "") => {
    let ret = []

    for (let key in obj) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        if (Array.isArray(obj[key])) {
          ret.push({ key: prefix + key, value: obj[key] })
        } else {
          ret = ret.concat(flattenErrorDetails(obj[key], prefix + key + "."))
        }
      } else {
        ret.push({ key: prefix + key, value: obj[key] })
      }
    }

    return ret
  }

  const errorHandler = ({ error, showSessionStatus = true }) => {
    const accessToken = getAccessToken()
    const refreshToken = getRefreshToken()

    if (showSessionStatus) {
      if (!accessToken && !refreshToken) {
        openToastNotification("info", "You Are Logged Out", "Please Log In to Continue.")
        logout()
        return error
      } else if (isRefreshTokenExpired()) {
        openToastNotification("info", "Session Timed Out", "Please Log In to Continue.")
        logout()
        return error
      }
    }

    if (error?.message && error?.stack && !error?.response?.status) {
      return
    }

    if (error?.response?.status === 307 || error?.response?.status === 401) {
      return error
    }

    let errorMsg = ""
    if (typeof error === "string") {
      // react query error
      errorMsg = error
    } else if (error?.response?.data?.error) {
      // check server errors
      const errorData = error.response.data.error
      let details = []

      if (errorData.details) {
        const values = flattenErrorDetails(errorData?.details)

        details = values
          .filter((obj) => obj.value !== null)
          .map((obj) => {
            return (
              <div key={obj.key}>
                {/* not showing the obj.key, ie, field key, error */}
                <ul style={{ paddingInlineStart: 16 }}>
                  {obj.value.map((msg) => {
                    return <li key={obj.key + msg}>{msg}</li>
                  })}
                </ul>
              </div>
            )
          })
      }

      errorMsg = (
        <Flex vertical>
          {errorData.msg && <p style={{ marginBottom: 4 }}>{errorData.msg}</p>}
          {details && <Flex vertical>{details}</Flex>}
        </Flex>
      )
    } else if (error instanceof Error) {
      // JS Error
      errorMsg = error.message
    }
    openToastNotification("error", "Error", errorMsg)
    return error
  }

  return {
    flattenErrorDetails,
    errorHandler,
  }
}

export default useErrors
